import { FC } from 'react';
import { Button } from 'antd';
import { keycloak } from 'shared/api';
import styles from './PendingPage.module.scss';

export const PendingPage: FC = () => {
  const handleLogout = () => {
    // Полный разлогин в Keycloak
    keycloak.logout();
  };

  return (
    <div className={styles.pendingPage}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#1890ff" strokeWidth="2" fill="none" />
            <path d="M12 6v6l4 2" stroke="#1890ff" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <h1 className={styles.title}>
          Регистрация на рассмотрении
        </h1>
        <p className={styles.description}>
          Ваша регистрация находится на рассмотрении администратора.
          Обычно это занимает несколько рабочих дней.
        </p>
        <div className={styles.actions}>
          <p className={styles.helpText}>
            Если у вас есть вопросы или требуется срочное рассмотрение,
            обратитесь к администратору системы.
          </p>
          <Button
            type="primary"
            size="large"
            onClick={handleLogout}
            className={styles.logoutButton}
          >
            Выйти из системы
          </Button>
        </div>
      </div>
    </div>
  );
};
